





































































import { DateTime } from 'luxon';

import { getUserGameTransactions } from '@/api/Transaction';

import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';

import formatDate from '@/helpers/formatDate';
import { textOverflowMiddle } from '@/helpers/formatString';
import { copyToClipBoard } from '@/helpers/copyToClipBoard';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { getLinkToGameTransaction } from '@/helpers/explorerHelper';

export default {
  name: 'UserManagementGameTransactionsTab',
  components: {
    VExtendedDataPicker
  },
  props: {
    operatorUserWalletHash: {
      type: String,
      default: (): string => null
    }
  },
  data(): any {
    return {
      currentPage: 1,
      previousPageLastDate: [],
      selectedDate: DateTime.now().toFormat('yyyy-LL-dd'),
      isLoading: false,
      transactions: [],
      hasNext: false
    };
  },
  computed: {
    paginationLength(): number {
      return this.currentPage + (this.hasNext ? 1 : 0);
    },
    tableHeaders(): { [key: string]: string | boolean }[] {
      return [
        {
          text: 'Date',
          value: 'date',
          width: '150px'
        },
        {
          text: 'Type',
          value: 'actionType',
          width: '20%'
        },
        {
          text: 'Amount',
          value: 'amount',
          width: '20%'
        },
        {
          text: 'Play to Earn Reward',
          value: 'reward',
          width: '20%'
        },
        {
          text: 'Transaction ID',
          value: 'hash',
          width: '20%'
        },
        {
          text: 'Action',
          value: 'action',
          width: '20%'
        }
      ];
    }
  },

  watch: {
    operatorUserWalletHash: {
      async handler(newId: number | null): Promise<void> {
        if (!newId) {
          return;
        }

        await this.$nextTick();
        await this.fetchTransactions();
      },
      immediate: true
    }
  },

  methods: {
    textOverflowMiddle,
    copyToClipBoard,
    getLinkToGameTransaction,
    getFormatDate(date: string): string {
      return formatDate(
        date.slice(0, date.lastIndexOf('.')),
        'yy.MM.dd HH:mm',
        true,
        false
      );
    },
    async fetchTransactions(date?: string): Promise<void> {
      try {
        this.isLoading = true;

        const { gameActions, hasNext } = await getUserGameTransactions({
          walletHash: this.operatorUserWalletHash,
          size: 10,
          to: date || `${this.selectedDate}T23:59:59.999`
        });

        this.transactions = gameActions;
        this.hasNext = hasNext;
      } catch (error) {
        this.transactions = [];
        this.hasNext = false;

        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleOnPageChange(page: number): Promise<void> {
      try {
        const listLength = this.transactions?.length;
        const date =
          page === 1
            ? null
            : this.previousPageLastDate[page] ||
              this.transactions[listLength - 1].date;

        await this.fetchTransactions(date);

        this.currentPage = page;
        page === 1
          ? (this.previousPageLastDate = [])
          : (this.previousPageLastDate[page] = date);
      } catch (error) {
        console.error('handleOnPageChange', error);
      }
    },
    handleOnDateChange(date: string): void {
      this.selectedDate = date;
      this.resetPagination();
      this.fetchTransactions();
    },
    resetPagination(): void {
      this.currentPage = 1;
      this.previousPageLastDate = [];
    }
  }
};
